import { createContext } from 'react'

const contextPayload = {
  userType: null
}

/**
 * The AuthProvider context.
 */
export const AuthProviderContext = createContext(contextPayload)

AuthProviderContext.displayName = 'auth-provider_context'
